export const createLut = (list, keySelector = 'id') => 
  list.reduce((acc, e) => { acc[e[keySelector]] = e; return acc}, {})

export const reversePairs = (pairs) => Object.keys(pairs)
  .reduce((acc, key) => {acc[pairs[key]] = key; return acc}, {})

export const toTrueMap = (list) =>
  list.reduce((acc, e) => { acc[e] = true; return acc}, {})